module.exports = __webpack_public_path__ + "img/fetart.9e57f7d8.png";